import { Preset } from './../preset/preset.model';
import { UserActionLogRequest } from './../models/user-action-log.model';
import { AuthResponse, LoginOutCome, MfaRequiredErrorBody } from './../models/login.models';
import { Injectable } from '@angular/core';
import { MsgBoxService } from '../msg-boxes/msg-box.service';
import { AppConfig } from '../app.config';
import { BehaviorSubject, Observable, Subscription, interval, of, throwError, forkJoin } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ObjectType } from '@core_n/asp/AspObject';
import { aspMngr } from '@core_n/asp/AspMngr';
import { ISensorsPool } from '@core_n/asp/interfaces';
import { catchError, map } from 'rxjs/operators';
import { UserName } from '@core_n/common/settings';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import * as units from '@core_n/common/units';
import * as utils from "../common/utils";

export interface CameraInfo {
  cameraId: string;
  cameraStreamName: string;
  activeStreamName: string;
  cameraName: string;
  lastUpdateDate?: string;
  lastUpdateUser?: string;
  hasInStream?: boolean | null;
  hasOutStream?: boolean;
  connectionStatusLastUpdateDate?: string;
}

export interface AnalysisInfo {
  cameraId: string;
  cameraStreamName: string;
  cameraName: string;
  lastUpdateDate: string;
  lastUpdateUser: string;
}

@Injectable({
  providedIn: 'root'
})

export class VideoMsgMngrService {
  private channelTaskRun!: Subscription;

  private TokenURL: string = "";
  private DataURL: string = "";
  private CameraTokenURL: string = "";
  private CameraWebRtcTokenURL :string =""
  private CameraChannelReqURL: string = "";
  private SetChannelStreamConnectionStateURL: string = "";
  private SetChannelDaynamicStreamConnectionStateURL: string = "";
  private CameraChannelTable: string = "";
  private GetCameraRtspURL: string = "";
  private CameraGetAnalysisListURL: string = "";
  private CameraSetAnalysisURL: string = "";
  private CameraUpdateStatusURL: string = "";
  private CameraAddUpdateURL: string = "";
  private logUserActionURL: string = "";
  private presetsBaseUrl: string = "";

  private Token: string | null = null;
  private mfaToken: string | null = null;
  private DATA: any;
  public countOpenVideo: number;

  readonly ChannelList$ = new BehaviorSubject<Map<string, CameraInfo>>(new Map());
  readonly VideosInAnalysis$ = new BehaviorSubject<AnalysisInfo[]>([]);

  constructor(private msgBoxSrv: MsgBoxService, private http: HttpClient) {
    this.TokenURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.tokenAddress;
    this.DataURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.address;
    this.CameraTokenURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.cameraTokenAddress;
    this.CameraWebRtcTokenURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.cameraWebRtcTokenAddress;
    this.CameraChannelReqURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.channelChangeAddress;
    this.SetChannelStreamConnectionStateURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.setChannelStreamConnectionState;
    this.SetChannelDaynamicStreamConnectionStateURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.setChannelDaynamicStreamConnectionState;
    this.CameraChannelTable = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.cameraChannelTable;
    this.CameraGetAnalysisListURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.cameraGetAnalysisListURL;
    this.CameraSetAnalysisURL = AppConfig.settings.videoAddress.baseURL + AppConfig.settings.videoAddress.cameraSetAnalysisURL;
    this.CameraUpdateStatusURL = AppConfig.settings.videoAddress.baseURL + 'Cameras/UpdateCameraStatus';
    this.CameraAddUpdateURL = AppConfig.settings.videoAddress.baseURL + 'Cameras/AddUpdateCamera';
    this.GetCameraRtspURL = AppConfig.settings.videoAddress.baseURL + 'WowzaAPI/GetStreamSource';
    this.logUserActionURL = AppConfig.settings.videoAddress.baseURL + 'Cameras/UserAction';
    this.presetsBaseUrl = AppConfig.settings.videoAddress.baseURL + 'presets';
    this.countOpenVideo = 0;
    this.channelTaskRun = interval(AppConfig.settings.videoAddress.pullChannelListEvery).subscribe(() => {

      if (AppConfig.validateToken && !this.Token)
        return;
      this.updateChannelsTable();
      this.updateAnalysisList();
    })
  }

  authenticate(user: string, pass: string): Observable<LoginOutCome> {
    const headers = new HttpHeaders({
      'content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    });

    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', user)
      .set('password', pass)
      .set('scope', 'test');

    return this.http.post(this.TokenURL, body.toString(), { headers }).pipe(
      map(token => ({ kind: "success", authResponse: token }) as LoginOutCome),
      catchError((err: HttpErrorResponse) => {
        if ((err.status == 400 || err.status == 401) && err.error?.length > 1) {
          const jsonString = err.error.split("}{")[0] + '}';
          if (!jsonString) {
            return throwError(err);
          }
          const details = JSON.parse(jsonString) as MfaRequiredErrorBody
          if (details && details.error === "mfa_required")
            return of({ kind: 'mfa', details } as LoginOutCome);
        }
        console.error(err);
        return throwError(err);
      })
    );
  }

  verifyMfa(mfaToken: string, otp: string): Observable<AuthResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const body = new HttpParams()
      .set('grant_type', 'mfa_otp')
      .set('mfa_token', mfaToken)
      .set('otp', otp)
      .set('scope', 'test');

    return this.http.post<AuthResponse>(this.TokenURL, body.toString(), { headers });
  }

  getcountOpenVideo(): number {
    return this.countOpenVideo;
  }

  setcountOpenVideo(num: number) {
    this.countOpenVideo = this.countOpenVideo + num;
  }
  setToken(token: string): void {
    this.Token = token;
  }

  getToken(): string | null {
    return this.Token;
  }

  setMfaToken(token: string): void {
    this.mfaToken = token;
  }

  getMfaToken(): string | null {
    return this.mfaToken;
  }

  getData(): any {
    return this.DATA;
  }

  getSensorsList() {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Get Sensors List, No Login Token available...");
      return;
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    const jsonurl = 'assets/acoustic-sensors/acoustic-sensors.json';
    const vidoe$ = this.http.get<any[]>(this.DataURL, { headers }).pipe(
      catchError(err => {
        console.error("video sensors failed", err);
        this.msgBoxSrv.showErrorMsg("Could not get Video Sensors");
        return of([]);
      })
    );
    const acoustic$ = this.http.get<any[]>(jsonurl, { headers }).pipe(
      catchError(err => {
        console.error("acoustic sensors failed", err);
        this.msgBoxSrv.showErrorMsg("Could not get acoustic Sensors");
        return of([]);
      })
    );

    forkJoin({
      videoData: vidoe$,
      acousticData: acoustic$
    }).subscribe({
      next: (result) => {
        const sensorPool = aspMngr.getObjectsPool(ObjectType.Sensor) as ISensorsPool

        if (result.acousticData.length > 0) sensorPool.loadSensors(result.acousticData);
        if (result.videoData.length > 0) sensorPool.loadSensors(result.videoData);

        this.updateChannelsTable();
        this.updateAnalysisList();
      }
    })
  }

  getVideoList() {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    this.http.get(this.DataURL, { headers }).subscribe(
      (Data) => {
        this.DATA = Data;  // not sure i need to save this...
        setTimeout(() => {
          (aspMngr.getObjectsPool(ObjectType.Sensor) as ISensorsPool).loadSensors(Data);
          this.updateChannelsTable();
          this.updateAnalysisList();
        }, 300);
      },
      (error) => {
        console.log(error.error);
        this.msgBoxSrv.showErrorMsg("Could not get Video Sensors... Login Session Expired... Re-Login...");
      }
    );
  }

  getAcousticSensorsList() {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    const jsonurl = 'assets/acoustic-sensors/acoustic-sensors.json';
    this.http.get(jsonurl, { headers }).subscribe(
      (Data) => {
        setTimeout(() => {
          (aspMngr.getObjectsPool(ObjectType.Sensor) as ISensorsPool).loadSensors(Data);
        }, 10);
      },
      (error) => {
        console.log(error.error);
        this.msgBoxSrv.showErrorMsg("Could not get Video Sensors... Login Session Expired... Re-Login...");
      }
    );
  }

  getStreamPrefixForCameraToken(videoLinkUrl: string, streamName: string): string {
    let streamPrefix = null;
    try {
      const parseUrl = new URL(videoLinkUrl);
      const pathName = parseUrl.pathname;
      streamPrefix = pathName.substring(0, pathName.toLowerCase().indexOf(streamName.toLowerCase()));
      if (streamPrefix == '') {
        streamPrefix = null;
      }
      else {
        if (streamPrefix.startsWith('/')) {
          streamPrefix = streamPrefix.substring(1);
        }
        if (streamPrefix.endsWith('/')) {
          streamPrefix = streamPrefix.substring(0, streamPrefix.length - 1);
        }
      }
      // const parts = pathName.split('/').filter(Boolean);
      // const streamindex = parts.findIndex(part => part.includes(`${streamName}`));
      // if (streamindex === -1) return null;
      // const beforeStream = parts.slice(0, streamindex).join('/');
      // return beforeStream || null;
    }
    catch (err) {
      console.warn(`CAMERA TOKEN GENERATOR WARNING: failed to extract stream prefix for camera '${streamName}' from the camera url of:\t'${videoLinkUrl}'`, err);
    }
    return streamPrefix;
  }

  getCameraToken(streamName: string, streamPrefix: string): Observable<any> {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Get Camera Wowza Token! No Login Token available...");
      return null;
    }

    if (!this.CameraTokenURL || this.CameraTokenURL == "")
      return null;

    const params = new HttpParams({ fromObject: { streamName: streamName, streamPrefix: streamPrefix } });
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });
    return this.http.get(this.CameraTokenURL, { headers, params });
  }

  getCameraWebRtcToken(streamName: string, streamPrefix: string): Observable<any> {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Get Camera Wowza WebRtc SecureToken! No Login Token available...");
      return null;
    }

    if (!this.CameraWebRtcTokenURL || this.CameraWebRtcTokenURL == "")
      return null;

    const params = new HttpParams({ fromObject: { streamName: streamName, streamPrefix: streamPrefix } });
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    return this.http.get(this.CameraWebRtcTokenURL, { headers, params });
  }


  /*
    setVid2Chnl(streamName: string, channelName: string) {
      const headers = new HttpHeaders({
        'Connect-Type': 'application/json',
        Authorization: `Bearer ${this.Token}`
      });
  
      const payload = {
        StreamToChange: channelName,
        ChangeFromStream: streamName,
        ClientName: sessionStorage.getItem(UserName)
      };
  
      this.http.post<any>(this.CameraChannelReqURL, payload, { headers }).subscribe(
        (val) => {
          console.log("set video: ", streamName, " to stream name: ", channelName);
          this.updateChannelsTable();
        },
        (error) => {
          console.log("Cannot set video to stream name... ", error);
        }
      );
    }
  */
  setChannelStreamConnectionState(streamName: string, isActive: boolean) {
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    const payload = {
      ChannelStreamName: streamName,
      StartStop: isActive,
      ClientName: sessionStorage.getItem(UserName)
    };

    this.http.post<any>(this.SetChannelStreamConnectionStateURL, payload, { headers }).subscribe(
      (val) => {
        console.log("setChannelStreamConnectionState: ", streamName);
        this.updateChannelsTable();
      },
      (error) => {
        console.log("setChannelStreamConnectionState error ", error);
      }
    );
  }
  setChannelDaynamicStreamConnectionState(streamName: string, ChannelDaynamic: string, isRemove: boolean) {
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    const payload = {
      ChannelStreamName: streamName,
      isRemove: isRemove,
      ChannelDaynamicName: ChannelDaynamic,
      ClientName: sessionStorage.getItem(UserName)
    };

    this.http.post<any>(this.SetChannelDaynamicStreamConnectionStateURL, payload, { headers }).subscribe(
      (val) => {
        console.log("setChannelDaynamicStreamConnectionState: ", streamName);
        this.updateChannelsTable();
      },
      (error) => {
        console.log("setChannelDaynamicStreamConnectionState error ", error);
      }
    );
  }


  updateChannelsTable() {
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    this.http.get<any>(this.CameraChannelTable, { headers }).subscribe(data => {
      let channelList: Map<string, CameraInfo> = new Map();
      if (AppConfig.settings.ShowLogs) {
        console.debug(`[update-channels-table] api response:`);
        console.debug(data);
      }

      data.sort((a, b) => (b.activeStream != null ? 1 : 0) - (a.activeStream != null ? 1 : 0))


      for (const item of data) {
        if (!item?.channelName)
          continue;


        const pool = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj;
        const key1 = item.channelName?.toLowerCase();
        const key2 = item.activeStream?.toLowerCase();

        const sensor = (key1 && pool.get(key1)) || (key2 && pool.get(key2))

        if (!sensor) {
          continue;
        }

        channelList.set(item.channelName, {
          cameraId: item.id ? item.id : "",
          cameraStreamName: item.channelName ? item.channelName : "",
          activeStreamName: item.activeStream ? item.activeStream : "",
          cameraName: sensor.name ?? "missing",
          lastUpdateDate: item.lastUpdateDate ? units.datetime2Str(new Date(item.lastUpdateDate)) : "",
          lastUpdateUser: item.lastUpdateUser ? item.lastUpdateUser : "",
          hasInStream: item.hasInStream,
          hasOutStream: item.hasOutStream,
          connectionStatusLastUpdateDate: item.connectionStatusLastUpdateDate ? units.datetime2Str(new Date(item.connectionStatusLastUpdateDate)) : ""
        });
      }
      this.ChannelList$.next(channelList);
    })
  }

  updateAnalysisList() {
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    this.http.get<any>(this.CameraGetAnalysisListURL, { headers }).subscribe(data => {
      try {
        if (Array.isArray(data) && data.every(item => typeof item === 'string')) {
          let channelList: AnalysisInfo[] = [];
          for (const item of data) {
            const sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((item as string).toLowerCase());
            if (!sensor)
              continue;
            channelList.push({
              cameraId: "",
              cameraStreamName: item ? item : "",
              cameraName: sensor.name,
              lastUpdateDate: "",
              lastUpdateUser: ""
            });
          }
          this.VideosInAnalysis$.next(channelList);
        }
        else
          console.error("Cannot parse analysis")
      }
      catch (e) {
        console.error("Failed Getting analysis video list....: ", e);
      }
    })
  }

  isVideoInAnalysis(streamName: string): boolean {
    return this.VideosInAnalysis$.value.some(i => i.cameraStreamName === streamName);
  }

  getVideosInAnalysisList(): AnalysisInfo[] {
    return this.VideosInAnalysis$.value;
  }

  updateVideoAnalysisState(streamName: string, res: string, state: boolean) {
    let channel: string;
    try {
      channel = Array.from(this.ChannelList$.value.entries()).find(([key, camera]) => camera?.cameraStreamName === streamName)?.[0];
    }
    catch (e) {
      console.error("Cannot get Stream name Channel: " + e);
    }
    finally {
      if (channel == undefined)
        channel = '';

      const headers = new HttpHeaders({
        'Connect-Type': 'application/json',
        Authorization: `Bearer ${this.Token}`
      });

      const payload = {
        StreamName: streamName,
        IsActive: state,
        ClientName: sessionStorage.getItem(UserName),
        Resolution: res,
        ChannelNum: channel
      };

      this.http.post<any>(this.CameraSetAnalysisURL, payload, { headers }).subscribe(
        (val) => {
          console.log("set video: ", streamName, " to analysis state: ", state);
          this.updateAnalysisList();
        },
        (error) => {
          console.log("Cannot set video to channel... ", error);
        }
      );
    }
  }

  changeCameraStatus(cameraId: number, state: boolean) {

    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    const payload = {
      CameraId: cameraId,
      IsActive: state,
      ClientName: sessionStorage.getItem(UserName)
    };

    this.http.post<any>(this.CameraUpdateStatusURL, payload, { headers }).subscribe(
      (val) => {
        console.log("camera: ", cameraId, " status changed to: ", state);
      },
      (error) => {
        console.log("failed to update camera status in db", error);
      }
    );
  }


  addUpdateCamera(sensor: any, rstp: string): any {

    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    const payload = {
      Name: sensor.streamName,
      StreamName: sensor.streamName,
      Longitude: sensor.geometry.x,
      Latitude: sensor.geometry.y,
      Link: sensor.videoLink,
      StreamSourceUri: rstp,
      IsNewCamera: sensor.isNewCamera,
      ClientName: sessionStorage.getItem(UserName)
    };

    this.http.post<any>(this.CameraAddUpdateURL, payload, { headers }).subscribe(
      (val) => {
        console.log("stream name: ", sensor.streamName);
        return val;
      },
      (error) => {
        console.log("failed to add/update camera in db", error);
        return error;
      }
    );
  }

  getCameraRTSP(streamName: string): any {
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    this.http.get<string>(`${this.GetCameraRtspURL}?streamName=${streamName}`, { headers }).subscribe(data => {
      return data;
    })
  }

  logUserAction(payload: UserActionLogRequest): any {
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
      Authorization: `Bearer ${this.Token}`
    });

    this.http.post<any>(this.logUserActionURL, payload, { headers }).subscribe(
      (val) => {
      },
      (error) => {
        console.log(`failed to log user Action ${payload.actionType} camera in db`, error);

      }
    );
  }

  //Presets Area Start

  getPresets(): Observable<Preset[] | null> {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Get Preset List, No Login Token available...");
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    return this.http.get<Preset[]>(this.presetsBaseUrl, { headers }).pipe(catchError(
      error => {
        console.log(error.error);
        this.msgBoxSrv.showErrorMsg("Could not get Presets, check connectivity");
        return of(null);
      }
    ));
  }

  addPreset(preset: Preset): Observable<Preset | null> {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Save Preset, No Login Token available...");
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    const presetRequest = {
      ...utils.KeysFirstLetterUppercase(preset),
      Cameras: JSON.stringify(preset.cameras)
    };

    return this.http.post(this.presetsBaseUrl, presetRequest, { headers }).pipe(catchError(
      error => {
        this.msgBoxSrv.showErrorMsg("Could not Save Preset, check connectivity");
        return of(null);
      }
    ));
  }

  updatePreset(preset: Preset): Observable<Preset | null> {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Update Preset, No Login Token available...");
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    const presetRequest = {
      ...utils.KeysFirstLetterUppercase(preset),
      Cameras: JSON.stringify(preset.cameras)
    };

    return this.http.put(this.presetsBaseUrl + `/${preset.id}`, presetRequest, { headers }).pipe(catchError(
      error => {
        this.msgBoxSrv.showErrorMsg("Could not Update Preset");
        return of(null);
      }
    ));
  }

  removePreset(prestId: number): Observable<Preset | null> {
    if (AppConfig.validateToken && !this.Token) {
      this.msgBoxSrv.showErrorMsg("Cannot Delete Preset, No Login Token available...");
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.Token}`
    });

    return this.http.delete(this.presetsBaseUrl + `/${prestId}`, { headers }).pipe(catchError(
      error => {
        console.log(error.error);
        this.msgBoxSrv.showErrorMsg("Could not delete Preset");
        return of(null);
      }
    ));
  }

  //Presets Area End



}